/** One event in the Events list: a Today tag, the date, the title (up
 *  to two lines) and "24 people · 14 bookings". */
export function RailItem({
  active,
  onClick,
  title,
  date,
  meta,
  muted = false,
  today = false,
}: {
  active: boolean;
  onClick: () => void;
  title: string;
  date?: string;
  meta: string;
  muted?: boolean;
  today?: boolean;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-current={active ? "true" : undefined}
      className={`block min-h-11 w-full border-l-2 py-2.5 pr-3 pl-3.5 text-left transition-colors ${
        active
          ? "border-[color:var(--color-amber)] bg-[color:var(--color-paper)]"
          : "border-transparent hover:border-[color:var(--color-line-strong)] hover:bg-[color:var(--color-paper)]/60"
      }`}
    >
      {today ? (
        <span className="badge mb-1 bg-[color:var(--color-amber)] text-[color:var(--color-bg)]">
          Today
        </span>
      ) : null}
      {date ? (
        <span className="block text-[13px] text-[color:var(--color-ink-soft)]">
          {date}
        </span>
      ) : null}
      <span
        title={title}
        className={`mt-0.5 line-clamp-2 block text-[15px] leading-snug font-medium ${
          muted && !active
            ? "text-[color:var(--color-ink-soft)]"
            : "text-[color:var(--color-ink)]"
        }`}
      >
        {title}
      </span>
      <span className="mt-0.5 block text-[13px] text-[color:var(--color-ink-soft)] tabular-nums">
        {meta}
      </span>
    </button>
  );
}
